import { Platform, StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "../../Constants/baseStyles"
import Constants from "expo-constants"
import { basePadding } from "../../Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const headerStyles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: baseColors.white,
        borderBottomWidth: Platform.OS == "ios" ? 0.18 : 0.5,
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingBottom: 7,
        paddingTop: Constants.statusBarHeight,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.5,
        shadowRadius: 2
    },
    goBack: {
        flex: 1
    },
    logo: { flex: 2, alignContent: "center", alignItems: "center" },
    params: { flex: 1, alignItems: "center" }
})

export default headerStyles
